
// Generate dynamic year list from 2000 to current year
export const YEARS_LIST = Array.from(
    { length: new Date().getFullYear() - 2000 + 1 },
    (_, i) => new Date().getFullYear() - i
);
